// Sócios/testemunhas que assinam pela empresa — pode marcar vários (pedido
// 2026-10-14: "tem que deixar selecionar mais de 1"). A ordem em que foram
// marcados é a ordem das linhas de assinatura no contrato.
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ContractSignatory } from "@/services/gpsdrive-contracts.service";

// Contrato sem signatário salvo já nasce com todos os cadastrados marcados
// (pedido 2026-10-15: funcionário não precisa selecionar) — sócios primeiro,
// depois testemunhas. Dá pra desmarcar.
export function defaultSignatoryIds(signatories: ContractSignatory[] | undefined): string[] {
  const list = signatories ?? [];
  return [...list.filter((s) => s.role !== "testemunha"), ...list.filter((s) => s.role === "testemunha")].map((s) => s.id);
}

export function ContractSignatoryPicker({
  signatories,
  value,
  onChange,
  disabled,
}: {
  signatories: ContractSignatory[];
  value: string[];
  onChange: (ids: string[]) => void;
  disabled?: boolean;
}) {
  if (signatories.length === 0) {
    return (
      <div className="rounded-md border border-dashed border-border px-3 py-2 text-xs text-muted-foreground">
        Nenhum sócio/testemunha cadastrado (Administração &gt; Conta &amp; Integrações &gt; Contrato)
      </div>
    );
  }
  const toggle = (id: string) =>
    onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id]);
  return (
    <div className="flex flex-wrap gap-2">
      {signatories.map((s) => {
        const on = value.includes(s.id);
        const order = value.indexOf(s.id) + 1;
        return (
          <button
            key={s.id}
            type="button"
            disabled={disabled}
            onClick={() => toggle(s.id)}
            aria-pressed={on}
            className={cn(
              "flex items-center gap-2 rounded-lg border px-3 py-2 text-left text-sm transition-colors disabled:opacity-60",
              on ? "border-primary bg-primary/10" : "border-border hover:bg-muted/50",
            )}
          >
            <span
              className={cn(
                "grid h-5 w-5 shrink-0 place-items-center rounded border text-[10px] font-bold",
                on ? "border-primary bg-primary text-primary-foreground" : "border-muted-foreground/40",
              )}
            >
              {on ? (value.length > 1 ? order : <Check className="h-3.5 w-3.5" />) : null}
            </span>
            <span>
              <span className="block font-medium leading-tight">{s.name}</span>
              <span className="block text-[11px] text-muted-foreground">
                {s.role === "testemunha" ? "Testemunha" : "Sócio / signatário"}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}

// Contratos antigos só têm signatoryId.
export function contractSignatoryIds(c: { signatoryId: string | null; signatoryIds?: string[] } | null | undefined): string[] {
  if (!c) return [];
  return c.signatoryIds?.length ? c.signatoryIds : c.signatoryId ? [c.signatoryId] : [];
}
